import React from 'react';
import { Gamepad2 } from 'lucide-react';
import { GameLiveDemo } from './GameLiveDemo';

/**
 * Seção própria para Jogos Sociais (antes um card dentro de um grid
 * genérico). Fundo com "confetes" desfocados espalhados, em vez de um único
 * brilho centralizado — identidade lúdica específica desta seção.
 */
const GamesSpotlightSection = () => {
  return (
    <section className="relative py-20 md:py-28 bg-background overflow-hidden">
      <div
        className="absolute top-8 left-[8%] w-40 h-40 rounded-full opacity-25 blur-3xl pointer-events-none"
        style={{ background: 'radial-gradient(circle, rgb(var(--warm)) 0%, transparent 70%)' }}
        aria-hidden="true"
      />
      <div
        className="absolute bottom-4 left-[30%] w-24 h-24 rounded-full opacity-20 blur-2xl pointer-events-none"
        style={{ background: 'radial-gradient(circle, rgb(var(--primary)) 0%, transparent 70%)' }}
        aria-hidden="true"
      />
      <div
        className="absolute top-1/3 right-[6%] w-56 h-56 rounded-full opacity-25 blur-3xl pointer-events-none"
        style={{ background: 'radial-gradient(circle, rgb(var(--warm)) 0%, transparent 70%)' }}
        aria-hidden="true"
      />

      <div className="relative container mx-auto px-6 lg:px-16 xl:px-24 grid md:grid-cols-2 gap-12 items-center">
        <div className="order-2 md:order-1 w-full max-w-sm mx-auto">
          <GameLiveDemo />
        </div>

        <div className="order-1 md:order-2">
          <div className="inline-flex items-center gap-2 bg-warm/10 dark:bg-warm/15 px-3 py-1.5 rounded-full text-sm font-semibold text-foreground mb-5">
            <Gamepad2 className="w-4 h-4 text-warm-ink dark:text-warm" />
            Jogos Sociais
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-foreground">
            Aprendendo <span className="text-warm-ink dark:text-warm">brincando</span>
          </h2>
          <p className="font-body text-lg text-muted-foreground mt-4 max-w-md">
            Jogos que estimulam raciocínio, interação social e inteligência emocional.
          </p>
        </div>
      </div>
    </section>
  );
};

export default GamesSpotlightSection;
